import { createSelector } from 'reselect'
import { AppState } from 'store/types'

/**
 *
 * @param state - the application state
 * @returns originalShiftReducer
 */
export const selectOriginalShiftReducer = (state: AppState) =>
  state.originalShiftReducer

/**
 * Gets the originalShift from originalShiftReducer
 */
export const selectOriginalShift = createSelector(
  selectOriginalShiftReducer,
  selectOriginalShiftReducer => selectOriginalShiftReducer.originalShift,
)
